import "./PreUseHistory.scss";
import crossSvg from "../../common/icons/svg/cross.svg";
import { BED_DETAILS_MODULE, DEVICE_TYPES } from "../../common/constant/common-constants";
import PatientDetails from "../../components/PatientDetails/PatientDetails";
import TrendContainer from "../TrendContainer/TrendContainer";
import AlarmHistoryContainer from "../AlarmHistoryContainer/AlarmHistoryContainer";
import React, { useEffect, useRef, useState, useCallback } from "react";
import { connect } from "react-redux";
import ReportContainer from "../ReportContainer/ReportContainer";
import VitalDetailsContainer from "../VitalDetailsContainer/VitalDetailsContainer";
import NewTrendContainer from "../TrendContainer/NewTrendContainer";
import V730iPatientHistory from "../TrendContainer/PatientHistory/V730iPatientHistory";
import { TEMP_MODE, MODE } from "../../common/ENUMS/VENTILATOR_MODES_ENUM";
import { PATIENT_TYPE, VENTILATOR_ADDITIONAL_FEATURES } from "../../common/ENUMS/PARAMETER_ENUM";
import patientTypeAdult from "../../common/images/patient_type_adult.png";
import patientTypePediatric from "../../common/images/patient_type_pediatric.png";
import patientTypeNeonatal from "../../common/images/patient_type_neonatal.png";
import patientDetails from "../../common/images/patient_details.png";
import vitalGraphs from "../../common/images/vital_graphs.png";
import vitalTrends from "../../common/images/vital_trends.png";
import vitalReport from "../../common/images/vital_report.png";
import eventHistory from "../../common/images/event_history.png";
import { activeDeviceAction } from "../../modules/actions/action";
import DatePicker from "react-date-picker";
import TimePicker from 'react-time-picker';
import moment from "moment";
import arrow from "../../common/images/Vector.png";
import { setdeviceViewRedisChannels } from '../../socket/socket';
import { getPreUseModuleHeader, getPreUseTimeHeader, preUseGetStatusIcon } from "../../common/constant/common-constants";
import { getVentilatorPreUseHistory } from "../../helper/alarm-helper";
import { convertUTCtoIST } from "../../common/utils/CommonUtils";

function PreUseHistory(props) {
    const [selectedRowIndex, setSelectedRowIndex] = useState(0);
    const [preUseHistorydata, setPreUseHistoryData] = useState([]);
    const [endOffPage, setEndOffPage] = useState(false);
    const [createdAt, setCreatedAt] = useState(null);
    const [offset, setOffset] = useState(null);
    const isFetchingRef = useRef(false);
    const tableRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);

    const resetState = () => {
        setEndOffPage(false);
        setPreUseHistoryData([]);
        setCreatedAt(null);
        setOffset(null);
    }

    const getPreUseHistory = (created, offs) => {

        if (endOffPage) return;
        setIsLoading(true);
        getVentilatorPreUseHistory({
            bedId: props.bedId,
            createdAt: created ? created?.toString() : null,
            limit: 100,
            offset: offs ? offs : null,
        })
            .then((res) => {
                if (res?.length < 100) setEndOffPage(true);
                const preUseHistoryData = res;
                if (preUseHistoryData) {
                    if (!created) setCreatedAt(preUseHistoryData?.[0]?.time);
                    setPreUseHistoryData((prevData) => {
                        setOffset(prevData.length + preUseHistoryData.length);
                        return [...prevData, ...preUseHistoryData];
                    });
                }
            })
            .finally(() => {
                isFetchingRef.current = false;
                setIsLoading(false);
            })
            .catch((err) => {
                console.log("err in getPreUseHistory: ", err);
            });
    };

    const handleScroll = useCallback(() => {
        const table = tableRef.current;
        if (table) {
            const scrollPosition = table.scrollTop + table.clientHeight;
            const isLastRows = scrollPosition >= table.scrollHeight - table.clientHeight * 0.1;
            if (isLastRows && !isFetchingRef.current && offset) {
                isFetchingRef.current = true;
                getPreUseHistory(createdAt, offset);
            }
        }
    }, [offset]);

    useEffect(() => {
        const table = tableRef.current;
        if (table) {
            table.addEventListener('scroll', handleScroll);
        }

        return () => {
            // Cleanup: Remove the event listener when the component is unmounted
            if (table) {
                table.removeEventListener('scroll', handleScroll);
            }
        };
    }, [handleScroll]);

    useEffect(() => {
        if (!offset) {
            getPreUseHistory(null, null);
        }
    }, [offset])

    useEffect(() => {
        resetState();
    }, [props.bedId]);




    return (
        <div className="pre-use-history-container">
            {preUseHistorydata?.length > 0 ? (

                <>
                    <div className="pre-use-history-header">
                        Pre Use Tests
                    </div>
                    <div className="pre-use-history-tables">
                        <div className="pre-use-history-tables-left">
                            <div ref={tableRef} className="alarm-table-container">

                                <table className="alarm-table">
                                    <thead className="sticky">
                                        <tr>
                                            {getPreUseTimeHeader().map((data, count) => {
                                                return (
                                                    <th
                                                        key={count}
                                                        className="alarm-header"
                                                        style={{ position: "relative" }}
                                                    >
                                                        <div
                                                            className="header-content"
                                                        >
                                                            {data}

                                                        </div>
                                                    </th>
                                                );
                                            })}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            preUseHistorydata?.map((row, count) => {
                                                if (!row) return null;

                                                const isSelected = count === selectedRowIndex;
                                                const id = count + 1;
                                                const date = convertUTCtoIST(row?.time)?.date || '';
                                                const time = convertUTCtoIST(row?.time)?.time || '';
                                                const preUseStatus = row?.preUseStatus || '';

                                                return (
                                                    <tr key={count} onClick={() => setSelectedRowIndex(count)}
                                                        style={{
                                                            cursor: "pointer",
                                                            outline: isSelected ? "3px solid #6D1DF0" : "none",
                                                            outlineOffset: "-3.979999px",
                                                        }}
                                                    >
                                                        <td >
                                                            {id || '-'}
                                                        </td>
                                                        <td >
                                                            {date || '-'}
                                                        </td>
                                                        <td >
                                                            {time || '-'}
                                                        </td>
                                                        <td >
                                                            <div className="alarm-priority">
                                                                {preUseStatus && <img alt="priority icon" src={preUseGetStatusIcon(preUseStatus)?.icon} className="priority" width="25vw" />}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        }

                                    </tbody>
                                </table>

                                {isLoading && (
                                    <div className="spinner-container">
                                        <div className="spinner"></div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="pre-use-history-tables-right">
                            <div className="test-id">
                                Test ID : {selectedRowIndex + 1}
                            </div>

                            {preUseHistorydata?.[selectedRowIndex]?.tests?.length > 0 ? (
                                <>
                                    {preUseHistorydata?.[selectedRowIndex]?.preUseStatus?.toUpperCase() === 'PASSED' && (
                                        <div className="preuse-success-text">
                                            PreUse Passed
                                        </div>
                                    )}

                                    {(preUseHistorydata?.[selectedRowIndex]?.preUseStatus?.toUpperCase() === 'FAILED' ||
                                        preUseHistorydata?.[selectedRowIndex]?.preUseStatus?.toUpperCase() === 'INCOMPLETE') && (
                                            <div className="test-table-container">
                                                <div className="alarm-table-container">
                                                    <table className="alarm-table">
                                                        <thead className="sticky">
                                                            <tr>
                                                                {getPreUseModuleHeader().map((data, count) => (
                                                                    <th
                                                                        key={count}
                                                                        className="alarm-header"
                                                                        style={{ position: "relative" }}
                                                                    >
                                                                        <div className="header-content">{data}</div>
                                                                    </th>
                                                                ))}
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {preUseHistorydata?.[selectedRowIndex]?.tests
                                                                ?.filter(row => {
                                                                    if (!row) return false;

                                                                    // FAILED → show only failed tests
                                                                    if (
                                                                        preUseHistorydata?.[selectedRowIndex]?.preUseStatus?.toUpperCase() === 'FAILED'
                                                                    ) {
                                                                        return row.testStatus === "failed";
                                                                    }

                                                                    // WARNING → show all tests
                                                                    return true;
                                                                })
                                                                .map((row, count) => (
                                                                    <tr key={count}>
                                                                        <td>{row.moduleName || '-'}</td>
                                                                        <td>{row.testName || '-'}</td>
                                                                        <td>{row.errorCode || '-'}</td>
                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )}
                                </>
                            ) : (
                                <div className="no-test-data-container">
                                    No Test Details Available
                                </div>
                            )}


                        </div>
                    </div>
                </>
            ) : (
                <div className="no-data-container">
                    No Pre Use Test History Available
                </div>
            )}
        </div>
    )
}

const mapStateToProps = (state, ownProps) => {


    // let ventilatorStandby = state.deviceVitalDataReducer?.ventilatorStandby?.[ownProps.bedId];
    return {

        // ventilatorStandby: ventilatorStandby,

    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        // activeDeviceAction: (payload) => dispatch(activeDeviceAction(payload)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PreUseHistory);
